export default __webpack_public_path__ + "static/media/Cocoon.eab18e21.png";